import * as React from 'react';
import SearchIcon from '@atlaskit/icon/glyph/search';
import type { InjectedIntlProps } from 'react-intl';
import { injectIntl } from 'react-intl';
import i18n from './messages';
import modalI18n from 'view/search-modal/search-bar/messages';
import { Form, IconButton, Input, InputBackground } from './styled';
import { Flipped } from 'view/common/flip-toolkit';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

interface Props {
    value: string;
    onChange: AnyFunction1<React.ChangeEvent<HTMLInputElement>>;
    onSearch: AnyFunction;
    closeCustomizeSidebar: AnyFunction;
    onFocus?: () => void;
    autoFocus?: boolean;
    id?: string;
    searchBarShown?: boolean;
    placeHolderText?: string;
}

export class SearchTextbox extends React.Component<Props & InjectedIntlProps> {
    onSearch = (e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLFormElement>) => {
        const { onSearch, closeCustomizeSidebar } = this.props;
        e.preventDefault();
        onSearch();
        closeCustomizeSidebar();
    };

    render() {
        const { intl, value, onChange, onFocus, autoFocus, searchBarShown, placeHolderText, id } = this.props;
        const searchBarId = id || '';
        const inputElement = (
            <Input
                type="text"
                name="term"
                autoComplete="off"
                spellCheck={false}
                placeholder={placeHolderText || intl.formatMessage(modalI18n.input)}
                value={value}
                onFocus={onFocus}
                onChange={onChange}
                // Disabling existing violations, should be fixed when revisited.
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus={autoFocus}
            />
        );

        const showSearchTextbox = !searchBarShown;

        const animatedInputAndBackground = (
            <React.Fragment>
                {showSearchTextbox ? (
                    <Flipped flipId={`${searchBarId}search`} translate>
                        {inputElement}
                    </Flipped>
                ) : (
                    inputElement
                )}
                {/* The background must come after the input element in the DOM, so that the css selector for applying box shadowing will work properly */}
                {showSearchTextbox && (
                    <Flipped flipId={`${searchBarId}background`} translate scale>
                        <InputBackground />
                    </Flipped>
                )}
            </React.Fragment>
        );
        return (
            <Form
                onSubmit={this.onSearch}
                shown={showSearchTextbox}
                // search is opened on mouse down instead of click to avoid situations
                // in which users get focus without the search bar expanding
                onMouseDown={this.onSearch}
                id={searchBarId}
            >
                {animatedInputAndBackground}
                {showSearchTextbox && (
                    <Flipped flipId={`${searchBarId}icon`} translate>
                        <IconButton type="submit" actionSubjectId="search">
                            <SearchIcon
                                primaryColor={token('color.icon', colors.N200)}
                                label={intl.formatMessage(i18n.searchButton)}
                            />
                        </IconButton>
                    </Flipped>
                )}
            </Form>
        );
    }
}

export default injectIntl(SearchTextbox);
